export { ImageWithTextLanding } from './ImageWithTextLanding';